// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verify-password .verify-password-message[data-v-7751be43]{gap:16px 28px}@media(max-width:599px){.verify-password .verify-password-message[data-v-7751be43]{flex-direction:column;text-align:center}}@media(max-width:599px){.verify-password .verify-password-message .v-card__title[data-v-7751be43]{justify-content:center}}", ""]);
// Exports
module.exports = exports;
